import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/unmute.svg';

export const IconUnmute = createIconComponent(Icon);
